import { v4 as uuidv4 } from 'uuid';
// Error that is caused by a client and should be reported to the client
export class SimpleError extends Error {
    constructor(error) {
        super(error.message);
        this.code = error.code;
        this.message = error.message;
        this.human = error.human;
        this.field = error.field;
        this.statusCode = error.statusCode;
        this.id = error.id ?? this.generateID();
        this.meta = error.meta;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SimpleError);
        }
    }
    toString() {
        return this.code + ': ' + this.message + (this.field ? ' at ' + this.field : '') + ' (' + this.id + ')';
    }
    /**
     * Required to override the default toJSON behaviour of Error
     */
    toJSON() {
        return this.encode({ version: 0 });
    }
    encode(context) {
        return {
            id: this.id,
            code: this.code,
            message: this.message,
            human: this.human,
            field: this.field,
            meta: this.meta,
        };
    }
    static decode(data) {
        return new SimpleError({
            id: data.field('id').string,
            code: data.field('code').string,
            message: data.field('message').string,
            human: data.optionalField('human')?.string,
            field: data.optionalField('field')?.string,
            meta: data.optionalField('meta')?.value,
        });
    }
    hasCode(code) {
        return this.code === code;
    }
    getCode(code) {
        if (this.hasCode(code)) {
            return this;
        }
    }
    hasFieldThatStartsWith(prefix) {
        return !!this.field && this.field.startsWith(prefix);
    }
    doesMatchFields(fields) {
        for (const field of fields) {
            if (this.doesMatchField(field)) {
                return true;
            }
        }
        return false;
    }
    doesMatchField(field) {
        if (!this.field) {
            return false;
        }
        return this.field.startsWith(field);
    }
    generateID() {
        return uuidv4() + '@' + new Date().getTime();
    }
    addNamespace(field) {
        this.field = this.field ? field + '.' + this.field : field;
    }
    /// Returns a human description of all the errors
    getHuman() {
        return this.human ?? this.message;
    }
}
export function isSimpleError(e) {
    return e !== null && typeof e === 'object' && 'code' in e && 'message' in e && typeof e.code === 'string' && typeof e.message === 'string' && 'encode' in e && 'doesMatchFields' in e && 'doesMatchField' in e;
}
//# sourceMappingURL=SimpleError.js.map